export default __webpack_public_path__ + "static/media/YK.a5e79b9f.svg";